// Royal win chime (WebAudio, no asset) + vibration. Respects localStorage rl_win_chime ("off" disables).
export const chimeEnabled = () => localStorage.getItem("rl_win_chime") !== "off";

/* Quiet hours (saved from Me → mirrors users.quiet_hours): {enabled, start:"23:00", end:"06:00"} */
export const getQuietHours = () => { try { return JSON.parse(localStorage.getItem("rl_quiet_hours") || "null"); } catch { return null; } };
export const setQuietHours = (qh) => localStorage.setItem("rl_quiet_hours", JSON.stringify(qh));
export function inQuietHours(qh = getQuietHours(), now = new Date()) {
  if (!qh?.enabled) return false;
  const hm = `${String(now.getHours()).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}`;
  const a = qh.start || "23:00", b = qh.end || "06:00";
  return a <= b ? hm >= a && hm < b : hm >= a || hm < b;
}

export function playWinChime(force = false) {
  if (!chimeEnabled()) return;
  if (!force && inQuietHours()) return;
  try { navigator.vibrate?.([120, 60, 120, 60, 300]); } catch {}
  try {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return;
    const ctx = new AC();
    const notes = [[523.25, 0], [659.25, 0.12], [783.99, 0.24], [1046.5, 0.38]]; // C5 E5 G5 C6 — bright royal arpeggio
    notes.forEach(([f, t]) => {
      const o = ctx.createOscillator(), g = ctx.createGain();
      o.type = "triangle"; o.frequency.value = f;
      g.gain.setValueAtTime(0.0001, ctx.currentTime + t);
      g.gain.exponentialRampToValueAtTime(0.25, ctx.currentTime + t + 0.02);
      g.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + t + 0.7);
      o.connect(g).connect(ctx.destination);
      o.start(ctx.currentTime + t); o.stop(ctx.currentTime + t + 0.75);
    });
    setTimeout(() => ctx.close().catch(() => {}), 1500);
  } catch {}
}

/* Play once per win notification id (so polling doesn't repeat). */
export function chimeForNewWins(notifs) {
  const seen = new Set(JSON.parse(localStorage.getItem("rl_chimed_ids") || "[]"));
  const fresh = (notifs || []).filter((n) => !n.read && !seen.has(n.id) && /You Won|வென்ற|🎉/.test(n.title || "") && ["result_published", "win_alert"].includes(n.type));
  if (!fresh.length) return false;
  fresh.forEach((n) => seen.add(n.id));
  localStorage.setItem("rl_chimed_ids", JSON.stringify([...seen].slice(-200)));
  playWinChime();
  return true;
}
